import React from 'react';
import { TrendingUp, TrendingDown } from '../../utils/icons';

export interface StatCardProps {
  title: string;
  value: string | number;
  icon: React.ComponentType<any>;
  color?: 'primary' | 'blue' | 'green' | 'orange' | 'red';
  trend?: {
    value: number;
    label: string;
    isPositive: boolean;
  };
  subtitle?: string;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon: Icon,
  color = 'primary',
  trend,
  subtitle,
}) => {
  const colorClasses = {
    primary: 'bg-primary-700',
    blue: 'bg-primary-700',
    green: 'bg-primary-700',
    orange: 'bg-warning',
    red: 'bg-danger',
  };

  const iconBgClass = colorClasses[color];
  const valueClass = color === 'primary' ? 'text-primary-700' : 'text-slate-700';

  return (
    <div className="relative flex flex-col min-w-0 break-words dashboard-card rounded-2xl bg-clip-border">
      <div className="flex-auto p-4">
        <div className="flex flex-wrap -mx-3">
          <div className="flex-none w-auto max-w-full px-3">
            <div className={`relative inline-flex items-center justify-center w-16 h-16 text-white transition-all duration-200 rounded-lg ${iconBgClass}`}>
              <Icon className="text-white" size={24} />
            </div>
          </div>
          <div className="flex-none w-auto max-w-full px-3 my-auto">
            <div className="h-full">
              <p className="mb-0 font-semibold leading-normal text-sm text-slate-500">{title}</p>
              <h5 className={`mb-0 font-bold text-2xl ${valueClass}`}>{value}</h5>
              {subtitle && (
                <p className="mb-0 text-xs text-slate-500 mt-1">{subtitle}</p>
              )}
              {trend && (
                <div className="flex items-center mt-2">
                  <span className={`text-xs font-semibold flex items-center ${trend.isPositive ? 'text-primary-700' : 'text-danger'}`}>
                    {(() => {
                      const TrendIcon = (trend.isPositive ? TrendingUp : TrendingDown) as React.ComponentType<any>;
                      return <TrendIcon className="mr-1" size={12} />;
                    })()}
                    {trend.value}%
                  </span>
                  <span className="text-xs text-slate-500 ml-2">{trend.label}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
